"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import { loadScript } from "../utils";
function onKeyDownInputHandlers(e) {
    e.stopPropagation();
}
export const FormWrapper = /*#__PURE__*/ React.forwardRef(function FormWrapper(_param, ref) {
    var { className = "", state: initialState = "normal", onSubmit, children } = _param, props = _object_without_properties(_param, [
        "className",
        "state",
        "onSubmit",
        "children"
    ]);
    var _children_find;
    const [state, setState] = React.useState(initialState);
    var _children_find_props_dataname;
    const formName = (_children_find_props_dataname = ((_children_find = children.find((c)=>c.type === FormForm)) === null || _children_find === void 0 ? void 0 : _children_find.props)["data-name"]) !== null && _children_find_props_dataname !== void 0 ? _children_find_props_dataname : "Form";
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-form"
    }, props), {
        ref
    }), React.Children.map(children, (child)=>{
        if (child.type === FormForm) {
            const style = {};
            if (state === "success") {
                style.display = "none";
            }
            return /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, child.props), {
                style,
                onSubmit: (e)=>{
                    try {
                        e.preventDefault();
                        if (window.grecaptcha) {
                            var _window_grecaptcha;
                            if (!((_window_grecaptcha = window.grecaptcha) === null || _window_grecaptcha === void 0 ? void 0 : _window_grecaptcha.getResponse())) {
                                alert(`Please confirm you’re not a robot.`);
                                return;
                            }
                        }
                        if (onSubmit) {
                            onSubmit(e);
                        }
                        setState("success");
                    } catch (err) {
                        setState("error");
                        throw err;
                    }
                },
                "aria-label": formName
            }));
        }
        if (child.type === FormSuccessMessage) {
            const style = {};
            if (state === "success") {
                style.display = "block";
            }
            if (state === "error") {
                style.display = "none";
            }
            return /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, child.props), {
                style,
                tabIndex: -1,
                role: "region",
                "aria-label": `${formName} success`
            }));
        }
        if (child.type === FormErrorMessage) {
            const style = {};
            if (state === "success") {
                style.display = "none";
            }
            if (state === "error") {
                style.display = "block";
            }
            return /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, child.props), {
                tabIndex: -1,
                role: "region",
                "aria-label": `${formName} failure`,
                style
            }));
        }
        return child;
    }));
});
export const FormForm = /*#__PURE__*/ React.forwardRef(function FormForm(props, ref) {
    return /*#__PURE__*/ React.createElement("form", _object_spread_props(_object_spread({}, props), {
        ref
    }));
});
export const FormBlockLabel = /*#__PURE__*/ React.forwardRef(function FormBlockLabel(props, ref) {
    return /*#__PURE__*/ React.createElement("label", _object_spread_props(_object_spread({}, props), {
        ref
    }));
});
export const FormTextInput = /*#__PURE__*/ React.forwardRef(function FormTextInput(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("input", _object_spread_props(_object_spread({}, props), {
        className: className + " w-input",
        onKeyDown: onKeyDownInputHandlers,
        ref
    }));
});
export const FormTextarea = /*#__PURE__*/ React.forwardRef(function FormTextarea(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("textarea", _object_spread_props(_object_spread({}, props), {
        className: className + " w-input",
        onKeyDown: onKeyDownInputHandlers,
        ref
    }));
});
export const FormInlineLabel = /*#__PURE__*/ React.forwardRef(function FormInlineLabel(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("span", _object_spread_props(_object_spread({
        className: className + " w-form-label"
    }, props), {
        ref
    }));
});
export const FormCheckboxWrapper = /*#__PURE__*/ React.forwardRef(function FormCheckboxWrapper(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("label", _object_spread_props(_object_spread({
        className: className + " w-checkbox"
    }, props), {
        ref
    }));
});
export const FormRadioWrapper = /*#__PURE__*/ React.forwardRef(function FormRadioWrapper(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("label", _object_spread_props(_object_spread({
        className: className + " w-radio"
    }, props), {
        ref
    }));
});
const HIDE_DEFAULT_INPUT_STYLES = {
    opacity: 0,
    position: "absolute",
    zIndex: -1
};
const CHECKED_CLASS = "w--redirected-checked";
const FOCUSED_CLASS = "w--redirected-focus";
const FOCUSED_VISIBLE_CLASS = "w--redirected-focus-visible";
export const FormBooleanInput = /*#__PURE__*/ React.forwardRef(function FormBooleanInput(_param, ref) {
    var { className = "", checked = false, type = "checkbox", inputType, customClassName } = _param, props = _object_without_properties(_param, [
        "className",
        "checked",
        "type",
        "inputType",
        "customClassName"
    ]);
    const [isChecked, setIsChecked] = React.useState(checked);
    const [isFocused, setIsFocused] = React.useState(false);
    const [isFocusedVisible, setIsFocusedVisible] = React.useState(false);
    const wasClicked = React.useRef(false);
    const inputProps = {
        checked: isChecked,
        type,
        onChange: (e)=>{
            if (props.onChange) props.onChange(e);
            setIsChecked((prevIsChecked)=>!prevIsChecked);
        },
        onClick: (e)=>{
            if (props.onClick) props.onClick(e);
            wasClicked.current = true;
        },
        onFocus: (e)=>{
            if (props.onFocus) props.onFocus(e);
            setIsFocused(true);
            if (!wasClicked.current) {
                setIsFocusedVisible(true);
            }
        },
        onBlur: (e)=>{
            if (props.onBlur) props.onBlur(e);
            setIsFocused(false);
            setIsFocusedVisible(false);
            wasClicked.current = false;
        },
        onKeyDown: onKeyDownInputHandlers
    };
    if (inputType === "custom") {
        const pseudoModeClasses = `${isChecked ? ` ${CHECKED_CLASS}` : ""}${isFocused ? ` ${FOCUSED_CLASS}` : ""}${isFocusedVisible ? ` ${FOCUSED_CLASS} ${FOCUSED_VISIBLE_CLASS}` : ""} ${customClassName !== null && customClassName !== void 0 ? customClassName : ""}`;
        const currentClassName = `${className}${pseudoModeClasses}`;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: currentClassName
        }), /*#__PURE__*/ React.createElement("input", _object_spread_props(_object_spread({
            ref: ref
        }, props, inputProps), {
            style: HIDE_DEFAULT_INPUT_STYLES
        })));
    }
    return /*#__PURE__*/ React.createElement("input", _object_spread({
        ref: ref,
        className: className
    }, props, inputProps));
});
export const FormCheckboxInput = /*#__PURE__*/ React.forwardRef(function FormCheckboxInput(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(FormBooleanInput, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        type: "checkbox",
        className: className + " w-checkbox-input"
    }));
});
export const FormRadioInput = /*#__PURE__*/ React.forwardRef(function FormRadioInput(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(FormBooleanInput, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        type: "radio",
        className: className + " w-radio-input"
    }));
});
const MAX_FILE_SIZE_DEFAULT = 10485760;
const FileUploadContext = /*#__PURE__*/ React.createContext({
    files: null,
    error: null,
    maxSize: MAX_FILE_SIZE_DEFAULT,
    setFiles: ()=>undefined,
    setError: ()=>undefined
});
export const FormFileUploadWrapper = /*#__PURE__*/ React.forwardRef(function FormFileUploadWrapper(_param, ref) {
    var { maxSize = MAX_FILE_SIZE_DEFAULT } = _param, props = _object_without_properties(_param, [
        "maxSize"
    ]);
    const [files, setFiles] = React.useState(null);
    const [error, setError] = React.useState(null);
    return /*#__PURE__*/ React.createElement(FileUploadContext.Provider, {
        value: {
            files,
            setFiles,
            error,
            setError,
            maxSize
        }
    }, /*#__PURE__*/ React.createElement(_FormFileUploadWrapper, _object_spread_props(_object_spread({}, props), {
        ref
    })));
});
export const _FormFileUploadWrapper = /*#__PURE__*/ React.forwardRef(function _FormFileUploadWrapper(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload"
    }, props), {
        ref
    }));
});
export const FormFileUploadDefault = /*#__PURE__*/ React.forwardRef(function FormFileUploadDefault(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const { files, error } = React.useContext(FileUploadContext);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload-default"
    }, props), {
        ref,
        style: _object_spread_props(_object_spread({}, props.style), {
            display: !files || error ? "block" : "none"
        })
    }));
});
export const FormFileUploadInput = /*#__PURE__*/ React.forwardRef(function FormFileUploadInput(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const { setFiles, setError, maxSize } = React.useContext(FileUploadContext);
    return /*#__PURE__*/ React.createElement("input", _object_spread_props(_object_spread({}, props), {
        className: className + " w-file-upload-input",
        type: "file",
        onKeyDown: onKeyDownInputHandlers,
        onChange: (e)=>{
            if (e.target.files) {
                if (e.target.files[0] && e.target.files[0].size <= maxSize) {
                    setError(null);
                    setFiles(e.target.files);
                } else setError("SIZE_ERROR");
            }
        },
        ref
    }));
});
export const FormFileUploadLabel = /*#__PURE__*/ React.forwardRef(function FormFileUploadLabel(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("label", _object_spread_props(_object_spread({
        className: className + " w-file-upload-label"
    }, props), {
        ref
    }));
});
export const FormFileUploadText = /*#__PURE__*/ React.forwardRef(function FormFileUploadText(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-inline-block"
    }, props), {
        ref
    }));
});
export const FormFileUploadInfo = /*#__PURE__*/ React.forwardRef(function FormFileUploadInfo(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload-info"
    }, props), {
        ref
    }));
});
export const FormFileUploadUploading = /*#__PURE__*/ React.forwardRef(function FormFileUploadUploading(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload-uploading",
        style: _object_spread_props(_object_spread({}, props.style), {
            display: "none"
        })
    }, props), {
        ref
    }));
});
export const FormFileUploadUploadingBtn = /*#__PURE__*/ React.forwardRef(function FormFileUploadUploadingBtn(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload-uploading-btn"
    }, props), {
        ref
    }));
});
export const FormFileUploadUploadingIcon = /*#__PURE__*/ React.forwardRef(function FormFileUploadUploadingIcon(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("svg", _object_spread_props(_object_spread({
        className: className + " icon w-icon-file-upload-uploading"
    }, props), {
        ref
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        opacity: ".2",
        d: "M15 30a15 15 0 1 1 0-30 15 15 0 0 1 0 30zm0-3a12 12 0 1 0 0-24 12 12 0 0 0 0 24z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        opacity: ".75",
        d: "M0 15A15 15 0 0 1 15 0v3A12 12 0 0 0 3 15H0z"
    }, /*#__PURE__*/ React.createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        dur: "0.6s",
        from: "0 15 15",
        repeatCount: "indefinite",
        to: "360 15 15",
        type: "rotate"
    }))));
});
export const FormFileUploadSuccess = /*#__PURE__*/ React.forwardRef(function FormFileUploadSuccess(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const { files, error } = React.useContext(FileUploadContext);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload-success"
    }, props), {
        ref,
        style: _object_spread_props(_object_spread({}, props.style), {
            display: Boolean(files) && !error ? "block" : "none"
        })
    }));
});
export const FormFileUploadFile = /*#__PURE__*/ React.forwardRef(function FormFileUploadFile(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload-file"
    }, props), {
        ref
    }));
});
export const FormFileUploadFileName = /*#__PURE__*/ React.forwardRef(function FormFileUploadFileName(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const { files } = React.useContext(FileUploadContext);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload-file-name"
    }, props), {
        ref
    }), files && files[0].name);
});
export const FormFileUploadRemoveLink = /*#__PURE__*/ React.forwardRef(function FormFileUploadRemoveLink(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const { setFiles } = React.useContext(FileUploadContext);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-remove-link"
    }, props), {
        ref,
        onClick: ()=>{
            setFiles(null);
        }
    }));
});
export const FormFileUploadError = /*#__PURE__*/ React.forwardRef(function FormFileUploadError(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const { error } = React.useContext(FileUploadContext);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload-error"
    }, props), {
        ref,
        style: _object_spread_props(_object_spread({}, props.style), {
            display: error ? "block" : "none"
        })
    }));
});
export const FormFileUploadErrorMsg = /*#__PURE__*/ React.forwardRef(function FormFileUploadErrorMsg(_param, ref) {
    var { errors, className = "" } = _param, props = _object_without_properties(_param, [
        "errors",
        "className"
    ]);
    const { error } = React.useContext(FileUploadContext);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-file-upload-error-msg"
    }, props), {
        ref
    }), errors[error !== null && error !== void 0 ? error : "GENERIC_ERROR"]);
});
export const FormButton = /*#__PURE__*/ React.forwardRef(function FormButton(_param, ref) {
    var { className = "", value } = _param, props = _object_without_properties(_param, [
        "className",
        "value"
    ]);
    return /*#__PURE__*/ React.createElement("input", _object_spread_props(_object_spread({}, props), {
        ref,
        type: "submit",
        value: value !== null && value !== void 0 ? value : "",
        className: className + " w-button",
        onKeyDown: onKeyDownInputHandlers
    }));
});
export const SearchForm = /*#__PURE__*/ React.forwardRef(function SearchForm(props, ref) {
    return /*#__PURE__*/ React.createElement("form", _object_spread_props(_object_spread({}, props), {
        ref
    }));
});
export const SearchInput = /*#__PURE__*/ React.forwardRef(function SearchInput(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("input", _object_spread_props(_object_spread({}, props), {
        type: "text",
        className: className + " w-input",
        onKeyDown: onKeyDownInputHandlers,
        ref
    }));
});
export const SearchButton = /*#__PURE__*/ React.forwardRef(function SearchButton(_param, ref) {
    var { value = "", className = "" } = _param, props = _object_without_properties(_param, [
        "value",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("input", _object_spread_props(_object_spread({}, props), {
        type: "submit",
        value,
        className: className + " w-button",
        onKeyDown: onKeyDownInputHandlers,
        ref
    }));
});
export const FormSuccessMessage = /*#__PURE__*/ React.forwardRef(function FormSuccessMessage(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-form-done"
    }, props), {
        ref
    }));
});
export const FormErrorMessage = /*#__PURE__*/ React.forwardRef(function FormErrorMessage(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-form-fail"
    }, props), {
        ref
    }));
});
function hasValue(str) {
    if (typeof str !== "string") return false;
    return str.replace(/^[s ]+|[s ]+$/g, "").length > 0;
}
export const FormSelect = /*#__PURE__*/ React.forwardRef(function FormSelect(_param, ref) {
    var { options, className = "" } = _param, props = _object_without_properties(_param, [
        "options",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("select", _object_spread_props(_object_spread({
        className: className + " w-select"
    }, props), {
        ref
    }), options.map(({ v, t }, index)=>/*#__PURE__*/ React.createElement("option", {
            key: index,
            value: hasValue(v) ? v : ""
        }, hasValue(t) ? t : "")));
});
export const FormReCaptcha = /*#__PURE__*/ React.forwardRef(function FormReCaptcha({ siteKey = "", theme = "light", size = "normal" }, ref) {
    React.useEffect(()=>{
        loadScript("https://www.google.com/recaptcha/api.js", {
            cacheRegex: /(http|https):\/\/(www)?.+\/recaptcha/
        });
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: "g-recaptcha",
        "data-sitekey": siteKey,
        "data-theme": theme,
        "data-size": size
    });
});
